module.exports = __webpack_public_path__ + "img/5D5D5D_CDCDCD_232323_ACACAC-256px.51eeff1a.png";